import type React from 'react';

interface XIconProps extends React.SVGProps<SVGSVGElement> {
  size?: number;
}

export function XIcon({ size = 24, ...props }: XIconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_17078_21796)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M13.1687 3.106C13.2263 3.04008 13.2704 2.96344 13.2985 2.88048C13.3265 2.79751 13.3379 2.70983 13.3321 2.62245C13.3262 2.53507 13.3032 2.4497 13.2644 2.37121C13.2255 2.29272 13.1716 2.22265 13.1057 2.165C13.0397 2.10735 12.9631 2.06325 12.8801 2.03521C12.7972 2.00718 12.7095 1.99576 12.6221 2.00161C12.5347 2.00746 12.4494 2.03047 12.3709 2.06931C12.2924 2.10815 12.2223 2.16208 12.1647 2.228L8.758 6.12133L5.86667 2.26667C5.80457 2.18387 5.72405 2.11667 5.63148 2.07038C5.53891 2.0241 5.43683 2 5.33333 2H2.66667C2.54286 2 2.4215 2.03448 2.31618 2.09957C2.21086 2.16466 2.12575 2.25779 2.07038 2.36852C2.01501 2.47926 1.99158 2.60323 2.00269 2.72654C2.01381 2.84984 2.05905 2.96762 2.13333 3.06667L6.42467 8.788L2.83133 12.8947C2.77368 12.9606 2.72958 13.0372 2.70155 13.1202C2.67351 13.2032 2.6621 13.2908 2.66795 13.3782C2.6738 13.4656 2.6968 13.551 2.73564 13.6295C2.77449 13.7079 2.82841 13.778 2.89433 13.8357C2.96026 13.8933 3.03689 13.9374 3.11986 13.9655C3.20282 13.9935 3.2905 14.0049 3.37788 13.9991C3.46526 13.9932 3.55063 13.9702 3.62912 13.9314C3.70761 13.8925 3.77768 13.8386 3.83533 13.7727L7.242 9.87867L10.1333 13.7333C10.1954 13.8161 10.276 13.8833 10.3685 13.9296C10.4611 13.9759 10.5632 14 10.6667 14H13.3333C13.4571 14 13.5785 13.9655 13.6838 13.9004C13.7891 13.8353 13.8742 13.7422 13.9296 13.6315C13.985 13.5207 14.0084 13.3968 13.9973 13.2735C13.9862 13.1502 13.941 13.0324 13.8667 12.9333L9.57533 7.212L13.1687 3.106ZM11 12.6667L4 3.33333H5L12 12.6667H11Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_17078_21796">
          <rect width="16" height="16" fill="currentColor" />
        </clipPath>
      </defs>
    </svg>
  );
}
